import React, { FC, PropsWithChildren } from 'react';

import styles from './RoiIrrHint.module.scss';

export const RoiIrrHint: FC<PropsWithChildren> = ({ children }) => (
  <span className={styles.wrapper} tabIndex={0}>
    <span className={styles.label}>{children}</span>
    <span className={styles.tooltip} role="tooltip">
      <span className={styles.card}>
        <span className={styles.item}>
          <b>ROI</b> — показатель, отображающий сколько прибыли или убытков принесла инвестиция
          относительно вложений (инвестиция + вознаграждение за инвестицию).
        </span>
        <span className={styles.item}>
          <b>IRR</b> — показатель среднегодовой доходности инвестиций, которая учитывает временную
          стоимость денег и может учитывать несколько потоков доходов и расходов в разные моменты
          времени.
        </span>
      </span>
    </span>
  </span>
);

export default RoiIrrHint;
